module.exports = __webpack_public_path__ + "static/other/starPodAll.1b33432a.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/starPodAll.json
// module id = 857
// module chunks = 0